import { useRef, useState } from "react";
import { createDesignReviewRequest } from "../../api/design";
import { useNavigate, useParams } from "react-router-dom";
import ApprovalLine from "../../components/approval/ApprovalLine";
import TableCell from "../../components/common/ui/TableCell";

export default function DesignReviewForm({ onSuccess }) {
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [discipline, setDiscipline] = useState("");
  const [comment, setComment] = useState("");
  const [attachment, setAttachment] = useState(null);
  const { id: projectId } = useParams();
  const approvalRef = useRef();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("project", projectId);
    formData.append("title", title);
    formData.append("category", category);
    formData.append("discipline", discipline);
    formData.append("comment", comment);
    if (attachment) formData.append("attachment", attachment);

    try {
      const res = await createDesignReviewRequest(formData);
      const dns = res?.data?.dns;
      if (!dns) throw new Error("DNS 생성 실패");

      await approvalRef.current?.save(dns);

      if (onSuccess) onSuccess();
      setTitle("");
      setCategory("");
      setDiscipline("");
      setComment("");
      setAttachment(null);
      
      alert("도면 검토 요청이 등록되었습니다.");
      navigate(`/project/${projectId}/design/request`);
    } catch (err) {
      console.error("검토 요청 등록 실패:", err);
      alert("요청 등록 중 오류가 발생했습니다.");
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="w-full bg-white rounded-xl p-6"
    >
      <h2 className="text-lg font-semibold mb-4">도면 검토 요청</h2>

      <div className="overflow-x-auto border rounded-lg">
        <table className="w-full border-collapse text-sm">
          <tbody className="divide-y divide-gray-200">
            {/* 제목 */}
            <tr className="divide-x divide-gray-200">
              <TableCell
                label="제목"
                editing={true}
                input={
                  <input
                    type="text"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    className="w-full border rounded px-3 py-2 text-sm"
                    placeholder="예: 철근 상세도 검토 요청"
                    required
                  />
                }
              />
            </tr>

            {/* 결재선 */}
            <tr className="divide-x divide-gray-200">
              <TableCell
                label="결재선"
                editing={true}
                input={
                  <div className="border rounded px-3 py-2 bg-gray-50">
                    <ApprovalLine ref={approvalRef} />
                  </div>
                }
              />
            </tr>

            {/* 카테고리 */}
            <tr className="divide-x divide-gray-200">
              <TableCell
                label="카테고리"
                editing={true}
                input={
                  <input
                    type="text"
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                    className="w-full border rounded px-3 py-2 text-sm"
                    placeholder="도면 / 사양서 / 보고서 등"
                  />
                }
              />
            </tr>

            {/* 공종 */}
            <tr className="divide-x divide-gray-200">
              <TableCell
                label="공종"
                editing={true}
                input={
                  <select
                    value={discipline}
                    onChange={(e) => setDiscipline(e.target.value)}
                    className="w-full border rounded px-3 py-2 text-sm bg-white"
                  >
                    <option value="">선택</option>
                    <option value="ARCH">건축</option>
                    <option value="STRU">구조</option>
                    <option value="ELEC">전기</option>
                    <option value="MECH">설비</option>
                    <option value="CIVIL">토목</option>
                    <option value="ETC">기타</option>
                  </select>
                }
              />
            </tr>

            {/* 검토 의견 */}
            <tr className="divide-x divide-gray-200 align-top">
              <TableCell
                label="검토 의견"
                editing={true}
                input={
                  <textarea
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    className="w-full border rounded px-3 py-2 text-sm"
                    rows={4}
                    placeholder="검토 요청 내용을 입력하세요"
                  />
                }
              />
            </tr>

            {/* 첨부파일 */}
            <tr className="divide-x divide-gray-200 align-top">
              <TableCell
                label="첨부파일"
                editing={true}
                input={
                  <input
                    type="file"
                    onChange={(e) => setAttachment(e.target.files[0])}
                    className="text-sm"
                  />
                }
              />
            </tr>
          </tbody>
        </table>
      </div>

      <div className="flex justify-end mt-5">
        <button
          type="submit"
          className="px-5 py-2 bg-indigo-600 text-white text-sm font-medium rounded-md hover:bg-indigo-700"
        >
          요청 등록
        </button>
      </div>
    </form>
  );
}
